import { render } from "./SellerDeliverySettings.vue?vue&type=template&id=f780b852&scoped=true"
import script from "./SellerDeliverySettings.vue?vue&type=script&lang=js"
export * from "./SellerDeliverySettings.vue?vue&type=script&lang=js"

import "./SellerDeliverySettings.vue?vue&type=style&index=0&id=f780b852&lang=css"
import "./SellerDeliverySettings.vue?vue&type=style&index=1&id=f780b852&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f780b852"]])

export default __exports__